// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if ({ "index":1,"lib-react":1,"vendors-node_modules_pnpm_rsbuild_core_2_2_8_node_modules_rsbuild_core_dist_client_overlay_js-7591ab":1 }[chunkId]) return "static/js/" + chunkId + ".js";
  // return url for filenames based on template
  return "static/js/async/" + chunkId + ".js"
}